
import { Outlet } from 'react-router-dom';
export type SolucionesDigitalesProps = {}
const SolucionesDigitalesModule:React.FC<SolucionesDigitalesProps> = () => {
  return (
    <Outlet/>
  )
}
export default SolucionesDigitalesModule